import React from 'react';
import { createPortal } from 'react-dom';
import Modal from './Modal';

let modalRoot = document.getElementById('modal-root');
if (!modalRoot) {
  modalRoot = document.createElement('div');
  modalRoot.setAttribute('id', 'modalRoot');
  document.body.appendChild(modalRoot);
}

const ModalPortal = (props) => createPortal(<Modal {...props} />, modalRoot);

export default ModalPortal;
